import { Input } from '../../ui/input';
import FieldError from '../FieldError';

export default function EquipmentStep({ formData, errors, handleChange }) {
  return (
    <div>
      <label className="text-blue-500 text-2xl font-bold mb-6 block">Equipment</label>
      <div className="space-y-6">
        <div>
          <Input
            type="text"
            placeholder="Truck #"
            value={formData.truckNumber}
            onChange={(e) => handleChange('truckNumber', e.target.value)}
            className={`w-full bg-white h-16 text-lg placeholder:text-gray-400 placeholder:italic ${
              errors.truckNumber ? 'border-red-500' : ''
            }`}
          />
          <FieldError message={errors.truckNumber} />
        </div>
        <Input
          type="text"
          placeholder="Trailer #"
          value={formData.trailerNumber}
          onChange={(e) => handleChange('trailerNumber', e.target.value)}
          className="w-full bg-white h-16 text-lg placeholder:text-gray-400 placeholder:italic"
        />
      </div>
    </div>
  );
}
